import React from "react";
import { Col, Modal, Row } from "react-bootstrap";
import UiButton from "../button/Button";

const PasaValidationModal = (props) => {
    return (
        <>

            <Modal
                size='md'
                aria-labelledby='contained-modal-title-vcenter'
                centered
                backdrop='static'
                className='save-session-modal'
                show={props.show}
                keyboard={false}
            >
                <Modal.Body className='text-center text-primary-title-label-color px-4 pt-4 pb-0'>
                    <React.Fragment>
                        <p className='font-weight-normal font-size-20 font-size-md-24 mb-0'> Sum Assured Is Not Match. Are you sure you want to
                            proceed with non-pasa ? </p>
                    </React.Fragment>
                </Modal.Body>
                <Modal.Footer className='d-block p-4 border-0'>
                    <Row className='modal-footer-row'>

                        <React.Fragment>
                            <Col xs='12' md='6'>
                                <UiButton onClick={() => { props.processToNonPasa() }} className='font-size-medium font-size-16 px-2 w-100 mb-2 mb-md-0' variant='secondary' buttonText='Proceed' />
                            </Col>
                            <Col xs='12' md='6'>
                                <UiButton onClick={() => { props.cancelModal() }} className='font-size-medium font-size-16 px-2 w-100 mb-2 mb-md-0' variant='secondary' buttonText='Cancel' />
                            </Col>

                        </React.Fragment>

                    </Row>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default PasaValidationModal;
